import React, { useState } from "react";
import { t } from "../../i18n";

const today = () => new Date().toLocaleDateString("en-CA");

// Asks for the departure date and an optional reason. Archiving keeps every record of the employee.
const ArchiveEmployeeModal = ({ employee, onClose, onConfirm, busy = false }) => {
  const [leftAt, setLeftAt] = useState(today());
  const [reason, setReason] = useState("");

  const submit = (event) => {
    event.preventDefault();
    if (!leftAt || busy) return;
    onConfirm({ left_at: leftAt, left_reason: reason.trim() || null });
  };

  return (
    <div className="modal-overlay">
      <form
        onSubmit={submit}
        role="dialog"
        aria-modal="true"
        aria-labelledby="archive-title"
        className="modal-panel max-w-md p-6"
      >
        <h2 id="archive-title" className="text-xl font-bold text-brand-600">
          {t("أرشفة الموظف: {name}", { name: employee.name })}
        </h2>
        <p className="mt-2 text-sm text-slate-600">
          {t(
            "يبقى سجل عمله ودفعاته وخصوماته وتقاريره كما هي، ويختفي من قوائم الموظفين النشطين ومن التسجيل اليومي."
          )}
        </p>

        <label htmlFor="archive-date" className="mt-4 block text-sm font-medium text-slate-700">
          {t("تاريخ المغادرة")}
        </label>
        <input
          id="archive-date"
          type="date"
          required
          value={leftAt}
          onChange={(e) => setLeftAt(e.target.value)}
          className="field mt-1"
        />

        <label htmlFor="archive-reason" className="mt-4 block text-sm font-medium text-slate-700">
          {t("السبب (اختياري)")}
        </label>
        <input
          id="archive-reason"
          type="text"
          maxLength={255}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="field mt-1"
        />

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="rounded-lg border border-slate-300 bg-card px-4 py-2 font-medium text-slate-700 hover:bg-slate-100"
          >
            {t("إلغاء")}
          </button>
          <button
            type="submit"
            disabled={busy || !leftAt}
            className="rounded-lg bg-brand-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-brand-700 disabled:opacity-60"
          >
            {busy ? t("جاري المعالجة...") : t("أرشفة")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ArchiveEmployeeModal;
